import { useHandleSuccess } from "@features/ottPurchase/hooks/useHandleSuccess";
import { useLocale } from "@/shared/hooks/useLocale";
import { useSearchParams } from "react-router";
import { useRedirectUrlOnSuccess } from "@features/ottPurchase/hooks/useRedirectUrlOnSuccess";
import { EmptyState } from "@motain/web-shared-hub/ui/blocks";
import { Button, ButtonVariant } from "@motain/web-shared-hub/ui/elements";

export const OTTSuccessContainer = () => {
  const { locale, t } = useLocale();
  const redirectUrl = useRedirectUrlOnSuccess();

  const [searchParams] = useSearchParams();
  const env = searchParams.get("env");
  const offerId = searchParams.get("offerId");

  useHandleSuccess({
    offerId: offerId || "",
    locale: locale,
    env: env || "",
    redirectUrl,
  });

  return (
    <>
      <EmptyState
        title={t("THANK_YOU_TITLE")}
        message={t("THANK_YOU_MESSAGE")}
        image={{
          alt: t("TWO_MAN_PLAYS_FOOTBALL_IMAGE_ALT"),
          src: "https://images.onefootball.com/cw/icons/players-on-phone.svg",
          width: 248,
          height: 248,
        }}
      />
      <div
        style={{
          display: "flex",
          placeContent: "center",
        }}
      >
        <Button as="a" href={redirectUrl} variant={ButtonVariant.fill}>
          {t("GO_TO_MATCH")}
        </Button>
      </div>
    </>
  );
};
